import * as React from 'react';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Grid from '@mui/material/Grid';
import { green } from '@mui/material/colors';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import { HighlightedCode } from '@mui/internal-core-docs/HighlightedCode';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/FormControl": FormControl, "@mui/material/FormLabel": FormLabel, "@mui/material/FormControlLabel": FormControlLabel, "@mui/material/RadioGroup": RadioGroup, "@mui/material/Radio": Radio, "@mui/material/Grid": Grid, "@mui/material/colors": { green }, "@mui/material/Typography": Typography, "@mui/material/Box": Box, "@mui/material/Button": Button, "@mui/material/Popover": Popover, "@mui/material/Input": Input, "@mui/material/InputLabel": InputLabel, "@mui/internal-core-docs/HighlightedCode": { HighlightedCode } } } });
export default ClientProvider;
